//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IGetHashtagsUsageResponse } from '@apis/instagram-hashtags-usage/instagramHashtagsUsageApiModels';
import { Serialized } from '@utils/types/Serialized';

/**
 * Deserializes dates in the hashtag usage response
 */
export function deserializeHashtagUsageDates(
  response: Serialized<IGetHashtagsUsageResponse>,
): IGetHashtagsUsageResponse {
  return {
    data: response.data.map((hashtag) => ({
      ...hashtag,
      startDate: hashtag.startDate ? new Date(hashtag.startDate) : undefined,
      endDate: hashtag.endDate ? new Date(hashtag.endDate) : undefined,
    })),
  };
}
